import React from 'react';

import Popover, { PopoverProps } from 'components/ui/Popover/Popover';

const FormErrorPopover: React.FC<
    Pick<PopoverProps, 'content' | 'visible' | 'placement' | 'offsetHorizontal' | 'children'>
> = ({ children, content, visible, offsetHorizontal = 0, placement = 'left' }) => {
    return (
        <Popover
            padding="L"
            frozen
            content={content}
            visible={visible}
            color="red"
            placement={placement}
            offsetHorizontal={offsetHorizontal}
        >
            {children}
        </Popover>
    );
};

export default FormErrorPopover;
